/** Build-time feature flags — see docs/P1-TEST-TRACKER-FIX-PLAN.md */

export const FRACTIONAL_ENABLED = process.env.REACT_APP_FRACTIONAL_ENABLED === "true";

/** Touchless lock/unlock mock UI (off by default until real telematics ships). */
export const TELEMATICS_MOCK_ENABLED = process.env.REACT_APP_TELEMATICS_MOCK_ENABLED === "true";

/**
 * Voice-first booking agent (POST /agent/turn). Off by default —
 * set REACT_APP_BOOKING_AGENT=true at build time to enable.
 */
export const BOOKING_AGENT_ENABLED = process.env.REACT_APP_BOOKING_AGENT === "true";
